var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStatisticsComment = function SvgIconStatisticsComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03 5.53h4.94M6.03 8.352h2.823M5.96 12.059l-2.716 1.523a.5.5 0 0 1-.745-.436V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.931a1 1 0 0 1-1 1H6.45a1 1 0 0 0-.49.128Z",
    stroke: "#000",
    strokeOpacity: 0.75,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconStatisticsComment;